import { buildPath } from "./buildPath";

export const circleAiArtefacts = {
  show: ({ uuid }: { uuid: string }) =>
    buildPath(`/internal_api/circle_ai/artefacts/${uuid}`),
};
